import { Locale } from 'modules/i18n';

export const bundleProgressLabelTranslation = {
  [Locale.en]: {
    iconTooltip: 'Data syncing: max 10 min after 1st request',
    linkTooltip: 'Max 10 min after 1st request',
    syncing: 'Usage data syncing',
    used: '{percent, number, ::compact-short}% used',
  },
};
